const wowApp = require('angular').module('wowApp.common');

wowApp.directive('bwsBanner', ['BannerService', '$location', '$sce', '$compile', 'BreakpointsService', 'AtmService', require('./banners-directive')]);
wowApp.service('BannerService', ['Restangular', require('./banner-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/banners/index.js
 **/